import { createSlice } from '@reduxjs/toolkit';
import { Product } from '@models';

interface ProductState {
  brands: string[];
  selectedProduct?: Product;
}

export const productSlice = createSlice({
  name: 'product',
  initialState: {
    value: {
      brands: [],
    } as ProductState,
  },
  reducers: {
    setBrands: (state, action: { type: string; payload: string[] }) => {
      state.value.brands = action.payload;
    },
    setSelectedProduct: (state, action: { type: string; payload: Product }) => {
      state.value.selectedProduct = action.payload;
    },
    setProductInitialState: (state) => {
      state.value = { brands: [] };
    },
  },
});

export const { setBrands, setSelectedProduct, setProductInitialState } = productSlice.actions;

export default productSlice.reducer;
